<template>
	<div>
		<cTable ref="table" :config="config" :fields="fields" :footer="{show:()=>false}"></cTable>
	</div>
</template>

<script>
	import cTable from "@/base/common/index";
	export default {
		components: {
			cTable
		},
		props:{
			read:{
				type:Boolean,
				default:false
			},
			list:{
				type:Array,
				default:()=>[]
			}
		},
		mounted(){
			
			setTimeout(()=>{
				this.$nextTick(()=>{
					if(this.$refs['table'])this.$refs['table'].list = this.list
				})
			},1000)
		},
		data() {
			return {
				config:{
					slot:'div',
					height:300,
					resize:false
				},
				fields:[
					{
						name: () => this.$t('skuName'),
						placeholder:()=>this.$t("skuName"),
						key: "name",
						minWidth: 130,
						component:!this.read&&'Input'
					},
					{
						name: () => this.$t("noofpieces"),
						placeholder:()=>this.$t("noofpieces"),
						key: "nums",
						minWidth: 130,
						component:!this.read&&'Input'
					},
					{
						name: () => this.$t("battery"),
						key: "is_electric",
						width: 130,
						component:!this.read&&'Select',
						placeholder:()=>this.$t("battery"),
						options:[],
						methods:{
							render({field,row}){
								return row[field.key] == 1?this.$t('YES'):this.$t('NO')
							},
							list({field}){
								if(!field.options.length){
									field.options = [
										{label:this.$t('YES'),value:1},
										{label:this.$t('NO'),value:2}
									]
								}
							}
						}
					},
					{
						name: () => this.$t("liquid"),
						placeholder:()=>this.$t("liquid"),
						key: "is_liquid",
						width: 130,
						component:!this.read&&'Select',
						options:[],
						methods:{
							render({field,row}){
								return row[field.key] == 1?this.$t('YES'):this.$t('NO')
							},
							list({field}){
								if(!field.options.length){
									field.options = [
										{label:this.$t('YES'),value:1},
										{label:this.$t('NO'),value:2}
									]
								}
							}
						}
					},
					{
					  type: "btns",
					  width: 160,
					  name: () => this.$t("operation"),
					  fixed: "right",
					  // width({ field }) {
					  //   return field.list.length * 40 + 40;
					  // },
					  list: [
					    {
					      name: () => this.$t("add"),
					      type: "add",
					      fnName: "add",
					      bind: {
					        type: "warning",
					      },
					      icon: "md-add",
								show:()=>{
									return !this.read
								},
					    },
					    {
					      name: () => this.$t("delete"),
					      type: "delete",
					      fnName: "delete",
					      icon: "md-trash",
								show:()=>{
									return !this.read
								},
					    },
					  ],
					  methods: {
					    add({ row,rowIndex }) {
								this.list.splice(rowIndex,0,{
								  goods_name:'',
								  goods_sku:'',
								  nums:'',
								  is_electric:'',
								  is_liquid:'',
								})
					    },
					    delete({ row,rowIndex }) {
								this.list.splice(rowIndex,1)
								if(!this.list.length)this.list.push({
									goods_name:'',
									goods_sku:'',
									nums:'',
									is_electric:'',
									is_liquid:'',
								})
					    },
					  },
					},
				]
			}
		},
	}
</script>

<style scoped>

</style>